import { apiService } from './apiService';

export interface IMaterial {
  _id: string;
  name: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export const materialApi = {
  // Get all materials
  getMaterials: async (): Promise<IMaterial[]> => {
    try {
      const response = await apiService.get('/materials');
      return response.data?.materials || [];
    } catch (error: any) {
      console.error('Error fetching materials:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch materials');
    }
  },

  // Get material by ID
  getMaterialById: async (materialId: string): Promise<IMaterial> => {
    try {
      const response = await apiService.get(`/materials/${materialId}`);
      return response.data;
    } catch (error: any) {
      console.error('Error fetching material:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch material');
    }
  }
};
